import { render } from "./OurCompany.vue?vue&type=template&id=204291aa"
import script from "./OurCompany.vue?vue&type=script&lang=js"
export * from "./OurCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__